import { locale } from '@/utils/locale';

export const dnsInProgressModalLocale = {
  title: locale('sitesWizard.tips.dnsInProgressModal.title'),
  description: locale('sitesWizard.tips.dnsInProgressModal.description'),
  backButton: locale('sitesWizard.tips.dnsInProgressModal.backButton'),
  continueButton: locale('sitesWizard.tips.dnsInProgressModal.continueButton'),
};
